/**
 * Table column configuration for the whiteboards list
 */
export const TABLE_COLUMNS = [
    {
        field: 'title',
        headerName: 'Chart name',
        flex: 1,
    },
    {
        field: 'userDisplayName',
        headerName: 'Author',
        flex: 1,
    },
    {
        field: 'updatedAt',
        headerName: 'Last Updated',
        flex: 1,
    },
];

